import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const DeleteModal = ({
  showDeleteModal,
  selectedRow,
  setShowDeleteModal,
  confirmDelete,
  loading,
}) => {
  return (
    <Modal
      isOpen={showDeleteModal}
      toggle={() => setShowDeleteModal(false)}
      centered
    >
      <ModalHeader toggle={() => setShowDeleteModal(false)}>
        Confirm Rejection
      </ModalHeader>

      <ModalBody>
        Are you sure you want to reject{" "}
        <strong style={{color:"#123b03ff"}}>{selectedRow?.qualification||selectedRow?.name}</strong>?
      </ModalBody>

      <ModalFooter>
        <Button
          color="secondary"
          onClick={() => setShowDeleteModal(false)}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button color="danger" onClick={confirmDelete} disabled={loading}>
          {loading ? "Rejecting..." : "Reject"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteModal;